import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../stores/platformAuthStore';
import { formStyles as styles } from '../components/formStyles';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    const r = await useAuthStore.getState().forgotPassword(email);
    setBusy(false);
    if (r.ok) setSent(true);
    else setError(r.error ?? 'Something went wrong');
  };

  return (
    <div style={styles.container}>
      <form style={styles.card} onSubmit={handleSubmit}>
        <h2 style={styles.title}>Forgot password</h2>
        {sent ? (
          <p style={styles.text}>
            If an account uses {email}, a link to reset its password is on its way. It works once,
            for 1 hour.
          </p>
        ) : (
          <>
            {error && <div style={styles.error}>{error}</div>}
            <div style={styles.field}>
              <label style={styles.label}>Email</label>
              <input
                style={styles.input}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>
            <button style={styles.btn} type="submit" disabled={busy}>
              {busy ? 'Sending...' : 'Send reset link'}
            </button>
          </>
        )}
        <div style={styles.footer}>
          <Link to="/login" style={styles.link}>
            Back to login
          </Link>
        </div>
      </form>
    </div>
  );
}
